import {Alert, useOpenModal} from '@/components/Modal/index.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'
import openWindow from '@/script/openWindow.mjs'

export default props => {
    const openModal = useOpenModal()
    const map = useMapContext()
    const {mapTypeCode} = map.data

    if ('_BD_MAP' !== mapTypeCode) {
        return null
    }

    const onClick = async () => {
        const uc = (() => {
            for (const n of map.root.children) {
                if ('BD_SU' === n.data.bizNodeType) {
                    return n.firstChild
                }
            }
        })()

        if (! uc) {
            await openModal(
                <Alert type="error">未找到集成用例</Alert>
            )

            return
        }

        const {prjId, sVer} = map.data
        const {sfName, pkid} = uc.data

        openWindow(
            '/Ai',

            {
                bizMap: {dpId: pkid, dpName: sfName},
                prjId,
                scene: 'GENERATE_UTC',
                sVer,
                title: `集成用例: ${sfName}`,
            }
        )
    }

    return {
        label: '集成测试用例',
        onClick,
        ...props,
    }
}
